import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { colorHelper } from "../../helpers/colorHelper";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import { rgbaToHex } from "../../helpers/colorHelper";

import "./ColorPickerStyles.css";

//Log
// Alla färger körs in som #
// filtrar bort unset och inherit
// TODO - sortera färgerna

const TemplateColors = ({ usedColors, onClick, path, className }) => {
  const handleClick = (color) => {
    let newColor = color;
    if (!color.includes("#") && !color.includes("rgb") && !color.includes("rgba")) {
      newColor = colorHelper.colourNameToHex(color);
      if (!newColor) return;
    }
    //TODO - Fixa bug. Läs bug.
    //BUG - convertedColor = null. (Type Error: cannot read properties of null(reading 'r'))
    // newColor funkar #hexkod
    // Testa att göra om ternary till if, inkl rgb2Hex ?
    let convertedColor = isHex(newColor) ? colorHelper.hexToRgb(newColor) : colorHelper.rgbToObject(newColor);
    onClick({ hex: "", rgb: convertedColor }, null, path);
  };
  const isHex = (color) => {
    if (color.toString().includes("#")) return true;

    return false;
  };

  const filterColors = (colors) => {
    let colors2 = [];
    //loopa igenom colors. sätt index 0 i en var/firstLet. Om..
    colors.forEach((e) => {
      let firstLet = e.substring(0, 1);
      if (colorHelper.colourNameToHex(e) != false) {
        colors2.push(colorHelper.colourNameToHex(e));
      } else if (firstLet === "#") {
      } else if (firstLet === "r") {
        colors2.push(rgbaToHex(e));
      }
      //mapa igenom färgerna i templete colors och kolla om varje item börjar med #, om inte, lägg till # i början av string.
      colors2.map((color) => {
        if (!color.startsWith("#")) {
          color = "#" + color;
        }
      });
    });
    //filtrera bort strings 'unset' och 'inherit' för att få bort dom tomma rutorna i color picker template colors.
    let filtered = colors2.filter((color) => !color.includes("unset", "inherit"));
    return Array.from(new Set([...filtered]));
  };
  const colors = filterColors(usedColors);
  return (
    <React.Fragment>
      <FormGroup className={className} style={{ margin: 0 }}>
        <Label for="exampleEmail" className={"temp-color-label" + " " + className}>
          <SystemLabel name="ColorsInTemplate" />
        </Label>
        <div className="color-toolbar-container">
          {colors.map((c, i) => {
            return (
              <div title={c} key={i} className="color-box-wrapper">
                <span>
                  <div onClick={() => handleClick(c)} style={{ backgroundColor: c }} className="color-box"></div>
                </span>
              </div>
            );
          })}
        </div>
      </FormGroup>
    </React.Fragment>
  );
};
function mapStateToProps(state) {
  return {
    usedColors: state.template.usedColors,
  };
}
export default connect(mapStateToProps)(TemplateColors);
